export default __webpack_public_path__ + "static/media/nokia.17716a00.svg";